



import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Chart } from '@antv/g2'
@Component
export default class extends Vue {
    @Prop() data!: []
    id = Math.floor(Math.random() * 1001 + 1) + 'line-chart'
    @Watch('data', {
      deep: true
    })
    renderChart () {
      const dom = document.getElementById(this.id)
      if (dom?.innerHTML) {
        dom.innerHTML = ''
      }
      const chart = new Chart({
        container: this.id,
        autoFit: true,
        height: 500,
        padding: [50, 50, 50, 50]
      })
      chart.clear()

      chart.data(this.data)
      chart.legend({
        position: 'top',
      })
      chart.scale({
        month: {
          range: [0, 1],
        },
        temperature: {
          nice: true,
        },
      })

      chart.tooltip({
        showCrosshairs: true,
        shared: true,
      })

      chart.axis('temperature', {
        label: {
          formatter: (val) => {
            return val
          },
        },
      })

      chart
        .line()
        .position('x*y')
        .color('alias')
        // .color('item', ['#00FF00', '#FFA500', '#FF0000', '#0000FF'])
        // .shape('smooth')

      chart
        .point()
        .position('x*y')
        // .color('alias')
        .shape('smooth')

      chart.render()
    }

    mounted () {
      this.renderChart()
    }
}
